// AI Generated Component
import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';

@Component({
    selector: 'notification-change',
    standalone: false,
    template: `
        <div class="notification-change" [class.cursor-pointer]="link" (click)="goTo()" [attr.aria-label]="title">
            <div class="col-sm-18 text-right mt-2 pr-0" *ngIf="faIcon">
                <span [class]="(digit > 0 ? classColor : 'text-link') + ' ' + faIcon"></span>
            </div>
            <div class="pl-1" [class]="faIcon ? 'col-sm-30' : 'col-sm-48'">
                <ul class="list-group mb-0">
                    <li class="remove-background list-group-item py-0 text-grey">
                        {{ title }}
                        <span *ngIf="tooltipTitle && tooltipTitle.length > 0"
                              class="fas fa-question-circle"
                              [ngbTooltip]="tooltipTitle">
                        </span>
                    </li>
                    <li class="py-0 remove-background list-group-item font-size-1-5 font-weight-500">
                        <span class="vtop font-size-1-5 font-weight-400 mt-1 mr-1">{{ digit | monNumber }}</span>
                        <span class="font-size-0-54 text-v-middle pt-2" [class]="miniDigitsIcon()"></span>
                        <span class="inline-block mt-2 font-size-0-7 text-v-middle font-weight-500"
                              [class]="miniDigitsTextColor()"
                              *ngIf="miniDigits !== undefined">
                            {{ displayPositive(miniDigits!) === '0' ? (displayPositive(miniDigits!) | monNumber) : '' }}
                        </span>
                        <span class="font-size-0-7 text-v-middle mt-1"
                              [class]="miniDigitsTextColor()"
                              [attr.unit]="unit">{{ unit }}</span>
                    </li>
                    <li class="remove-background list-group-item py-0 text-grey" style="margin-top: 9px">
                        <ng-content></ng-content>
                    </li>
                </ul>
            </div>
            <div class="clear"></div>
        </div>
    `,
})
export class NotificationChangeComponent implements OnInit {
    @Input() params: any;
    @Input() link?: string;
    @Input() faIcon?: string;
    @Input() title!: string;
    @Input() digit!: number;
    @Input() classColor?: string;
    @Input() miniDigits?: string | number;
    @Input() unit?: string;
    @Input() tooltipTitle?: string;

    constructor (private stateService: StateService) {}

    ngOnInit (): void {
        this.unit = this.unit || '';
    }

    displayPositive (num: string | number): string {
        const result = parseInt(num as string);
        return result !== 0 ? Math.abs(result).toString() : '';
    }

    goTo (): void {
        if (this.link) {
            this.params = this.params || {};
            this.stateService.go(this.link, this.params);
        }
    }

    miniDigitsTextColor (): string {
        if (this.miniDigits !== undefined) {
            const numValue = Number(this.miniDigits);
            if (numValue < 0) {
                return 'text-light-green';
            } else if (numValue > 0) {
                return 'text-danger';
            } else if (this.miniDigits === '0' || numValue === 0) {
                return 'text-grey';
            }
        }
        return '';
    }

    miniDigitsIcon (): string {
        if (this.miniDigits !== undefined) {
            const numValue = Number(this.miniDigits);
            if (numValue < 0) {
                return 'text-light-green fas fa-chevron-down';
            } else if (numValue > 0) {
                return 'fas fa-chevron-up text-danger';
            }
        }
        return '';
    }
}
